import { Injectable } from '@angular/core';
import { AspObject } from '../asp/AspObject';
import { IMenu } from '../common/inject';
import { IMapClickHandler, IMapMngr } from '../asp/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ObjectsMenuService {

  private menu: IMenu;

  public setMenu(menu: IMenu) {
    this.menu = menu;
  }

  public showObjectsMenu(objects: AspObject[], event, mapMngr: IMapMngr, mapClickHandler?: IMapClickHandler) {
    return this.menu.showObjectsMenu(objects, event, mapMngr, mapClickHandler);
  }

  public showContextMenu(objects: AspObject[], event, mapMngr: IMapMngr): boolean {
    return this.menu.showContextMenu(objects, event, mapMngr);
  }

  public handleKeyboardEvent(event: KeyboardEvent): boolean {
    return this.menu.handleKeyboardEvent(event);
  }

  //temp
  public hideAllMenus(){
    this.menu?.hideMenus();
  }
}
